import React, { useEffect, useContext } from "react";
import { Tag, Table } from "antd";
import moment from "moment";

import AttendanceDaysContext from "../../context/attendancedays/attendancedaysContext";
import AdministrativelDaysContext from "../../context/administrativedays/administrativedaysContext";

const MyRequests = () => {
  const attendanceDaysContext = useContext(AttendanceDaysContext);
  const administrativelDaysContext = useContext(AdministrativelDaysContext);

  const {
    attendanceRequests,
    loading,
    getAttendanceRequestsByCodEmployee,
  } = attendanceDaysContext;

  const { getTypes, types } = administrativelDaysContext;

  useEffect(() => {
    async function fetchData() {
      const user = JSON.parse(localStorage.getItem("user"));
      getAttendanceRequestsByCodEmployee(user.username);
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchGetTypes() {
      getTypes();
    }
    fetchGetTypes();
  }, []);

  const marginP = { margin: 0 };

  const columns = [
    {
      title: "Código colaborador",
      dataIndex: "CodigoEmpleado",
      key: "1",
    },
    {
      title: "Estado",
      dataIndex: "Estado",
      key: "2",
      render: (status) => (
        <Tag color={status === "P" ? "blue" : status === "A" ? "green" : "red"}>
          {status === "P"
            ? "Pendiente"
            : status === "A"
            ? "Aprobado"
            : "Rechazado"}
        </Tag>
      ),
    },
    {
      title: "Fecha Marcacion",
      dataIndex: "FechaMarcacion",
      key: "6",
      render: (text) => (
        <p style={marginP}>{moment.utc(text).format("DD-MM-YYYY")}</p>
      ),
    },
    {
      title: "Hora Marcacion",
      dataIndex: "HoraMarcacion",
      key: "7",
    },
    {
      title: "Tipo",
      dataIndex: "Tipo",
      key: "8",
      render: (tipo) => (
        <Tag color={tipo === "Entrada" ? "blue" : "red"}>
          {tipo}
        </Tag>
      ),
    },
    {
      title: "Mi comentario",
      dataIndex: "Comentario",
      key: "3",
    },
    {
      title: "Nombre jefe",
      dataIndex: "NombreJefe",
      key: "4",
    },
    {
      title: "Comentario jefe",
      dataIndex: "ComentarioJefe",
      key: "5",
    },
  ];

  if (!attendanceRequests) {
    return "loading...";
  }

  return <Table rowKey="Id" dataSource={attendanceRequests} columns={columns} loading={loading} scroll={{ x: 'auto' }} /> ;
};

export default MyRequests;
